import { createReducer } from '@reduxjs/toolkit'

import { resetFiltreCopies, setFilters } from '../actions/FiltreCopiesAction'
import { Filtre } from 'models'

export type FiltreCopiesType = Pick<
  Filtre,
  | 'csv'
  | 'titol'
  | 'nomOrgan'
  | 'dataDesde'
  | 'dataFins'
  | 'estatElaboracio'
  | 'origenDocument'
  | 'suport'
  | 'usuariNom'
  | 'identificador'
>

const initialFiltreCopies: FiltreCopiesType = {
  titol: '',
  nomOrgan: '',
  dataDesde: '',
  csv: '',
  dataFins: '',
  estatElaboracio: '',
  suport: '',
  origenDocument: '',
  usuariNom: '',
  identificador: ''
}

const filtreCopiesReducer = createReducer(initialFiltreCopies, (builder) => {
  builder
    .addCase(resetFiltreCopies, () => {
      return initialFiltreCopies
    })
    .addCase(setFilters, (_state, action) => {
      return action.payload
    })
})

export default filtreCopiesReducer
